import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilterIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 11,
	viewBox: "0 0 14 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0.5 0.5H13.5",
			strokeLinecap: "round",
			stroke: "#7284FA",
			strokeWidth: 1.25
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.5 5.3111H10.5",
			strokeLinecap: "round",
			stroke: "#7284FA",
			strokeWidth: 1.25
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.125 9.66666H7.875",
			strokeLinecap: "round",
			stroke: "#7284FA",
			strokeWidth: 1.25
		})
	]
});
export default SvgFilterIcon;
